import React, { useContext, useEffect, useMemo } from 'react';

import { LoaderDots } from '@shared/ui';
import { useGetFiles } from '@widgets/Files/hooks/useGetFiles';
import { useGetFoldersAndFilesFromParsedData } from '@widgets/Files/hooks/useGetFoldersAndFilesFromParsedData';
import { ContextFiles } from '@widgets/Files/model/context';
import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';

import { useFilesListWrapper } from './useFilesListWrapper';
import { useAppSelector } from '../../../store';
import { filesSelector } from '../../../store/slices/filesSlice/filesSlice';
import { FilesList } from '../FilesList/FilesList';
import { EmptyFilesList } from '../UI/EmptyFilesList/EmptyFilesList';

interface IFIlesListWrapperProps {
    parsedFilesData: IFIleEntity[];
}

export const FilesListWrapper = ({ parsedFilesData }: IFIlesListWrapperProps) => {
    const { files, folders } = useGetFoldersAndFilesFromParsedData({ parsedFilesData });

    if (!files.length && !folders.length) {
        return <EmptyFilesList />;
    }
    return <FilesList files={files} folders={folders} />;
};
